"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBulletinRestService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class MeetingBulletinRestService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '/meetings';
  }
  sendAllBulletinsToEmail(request, meetingId, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      this.send(utils_1.POST, '', `/${meetingId}/bulletins/zip`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(request)
      }), requestOptions);
    });
  }
  getMeetingAlert(options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', '/alert', options, requestOptions);
    });
  }
  getVotingData(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', `/${request.meetingId}/voting`, options, requestOptions);
    });
  }
  getBulletinData(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', `/${request.meetingId}/bulletins/${request.bulletinId}`, options, requestOptions);
    });
  }
  deleteBulletinsScanCopies(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      if (request.files.length) {
        request.files.map(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
          return file;
        });
      }
      const data = {
        ids: request.ids,
        comment: {
          body: request.html,
          attachments: request.files
        }
      };
      return this.send(utils_1.DELETE, '', `/${request.meetingId}/bulletins/${request.bulletinId}/files`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
  }
  sendToApproveBulletin(request, options = {}, requestOptions = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if ((_a = request === null || request === void 0 ? void 0 : request.files) === null || _a === void 0 ? void 0 : _a.length) {
        request.files.map(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
          return file;
        });
      }
      const data = {
        bulletin: request.bulletin,
        has_paper_bulletin: request.hasPaperBulletin,
        comment: {
          body: request.comment,
          attachments: request.files
        }
      };
      return this.send(utils_1.PATCH, '', `/${request.meetingId}/bulletins/${request.bulletinId}`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
  }
  submitVirtualVoting(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.POST, '', `/${request.meetingId}/agendas/vote`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(request.additionalData)
      }), requestOptions);
    });
  }
  approveBulletin(request, options = {}, requestOptions = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if ((_a = request === null || request === void 0 ? void 0 : request.files) === null || _a === void 0 ? void 0 : _a.length) {
        request.files.map(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
          return file;
        });
      }
      const data = {
        has_paper_bulletin: request.hasPaperBulletin,
        comment: {
          body: request.comment,
          attachments: request.files
        }
      };
      return this.send(utils_1.POST, '', `/${request.meetingId}/bulletins/${request.bulletinId}/review`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
  }
  downloadMyBulletin(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', `/${request.meetingId}/my_bulletins/download`, options, requestOptions);
    });
  }
}
exports.MeetingBulletinRestService = MeetingBulletinRestService;
const meetingBulletinRestService = new MeetingBulletinRestService();
exports.default = meetingBulletinRestService;